var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg11D(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 164.29 233.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:#231f20;}.cls-3{fill:#f16148;}.cls-4{fill:#bc141a;}.cls-32,.cls-5,.cls-63{fill:#fff;}.cls-5{mix-blend-mode:overlay;opacity:0.24;}.cls-6{fill:url(#linear-gradient);}.cls-7{fill:url(#linear-gradient-2);}.cls-8{fill:#fde4e0;}.cls-9{fill:#6f7173;}.cls-10{fill:url(#linear-gradient-3);}.cls-11{fill:#cc1217;}.cls-12{fill:url(#linear-gradient-4);}.cls-13{fill:url(#linear-gradient-5);}.cls-14{fill:url(#linear-gradient-6);}.cls-15{fill:url(#linear-gradient-7);}.cls-16{fill:url(#linear-gradient-8);}.cls-17{fill:url(#linear-gradient-9);}.cls-18{fill:url(#linear-gradient-10);}.cls-19{fill:url(#linear-gradient-11);}.cls-20{fill:#e64d3a;}.cls-21{fill:url(#linear-gradient-12);}.cls-22{fill:url(#linear-gradient-13);}.cls-23{fill:url(#linear-gradient-14);}.cls-24{fill:url(#linear-gradient-15);}.cls-25{fill:url(#linear-gradient-16);}.cls-26{fill:url(#linear-gradient-17);}.cls-27{fill:url(#linear-gradient-18);}.cls-28{fill:url(#linear-gradient-19);}.cls-29{fill:url(#linear-gradient-20);}.cls-30{fill:#efeff0;}.cls-31{opacity:0.37;}.cls-33{fill:#515254;}.cls-34,.cls-35{fill:#fdddc5;}.cls-35{opacity:0.19;}.cls-36{fill:url(#linear-gradient-21);}.cls-37{fill:url(#linear-gradient-22);}.cls-38{fill:url(#linear-gradient-23);}.cls-39{fill:url(#linear-gradient-24);}.cls-40{fill:url(#linear-gradient-25);}.cls-41{fill:url(#linear-gradient-26);}.cls-42{fill:url(#linear-gradient-27);}.cls-43{fill:url(#linear-gradient-28);}.cls-44{fill:url(#linear-gradient-29);}.cls-45{fill:url(#linear-gradient-30);}.cls-46{fill:url(#linear-gradient-31);}.cls-47{fill:url(#linear-gradient-32);}.cls-48{fill:url(#linear-gradient-33);}.cls-49{fill:url(#linear-gradient-34);}.cls-50{fill:url(#linear-gradient-35);}.cls-51{fill:url(#linear-gradient-36);}.cls-52{fill:url(#linear-gradient-37);}.cls-53{fill:url(#linear-gradient-38);}.cls-54{fill:url(#linear-gradient-39);}.cls-55{fill:url(#linear-gradient-40);}.cls-56{fill:url(#linear-gradient-41);}.cls-57{fill:url(#linear-gradient-42);}.cls-58{fill:url(#linear-gradient-43);}.cls-59{fill:#8d9092;}.cls-60{fill:url(#linear-gradient-44);}.cls-61{fill:url(#linear-gradient-45);}.cls-62{fill:url(#linear-gradient-46);}.cls-63{opacity:0.65;}.cls-64{fill:url(#linear-gradient-47);}.cls-65{fill:url(#linear-gradient-48);}.cls-66{fill:url(#linear-gradient-49);}.cls-67{fill:url(#linear-gradient-50);}.cls-68{fill:url(#linear-gradient-51);}.cls-69{fill:url(#linear-gradient-52);}.cls-70{fill:url(#linear-gradient-53);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -1479.14,
    y1: 83.04,
    x2: -1472.46,
    y2: 103.29,
    gradientTransform: "matrix(-1, 0, 0, 1, -1373.21, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ee492f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94070a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -1461.8,
    y1: 81.67,
    x2: -1415.69,
    y2: 81.67,
    gradientTransform: "matrix(-1, 0, 0, 1, -1373.21, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fec61b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c0151b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 46.25,
    y1: 26.58,
    x2: 94.13,
    y2: 26.58,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -232.36,
    y1: 1376.14,
    x2: -229.57,
    y2: 1381.37,
    gradientTransform: "matrix(-0.8, 0.61, 0.61, 0.8, -977.51, -875.63)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ee492f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c0151b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -232.77,
    y1: 1384.65,
    x2: -229.98,
    y2: 1389.88,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -233.18,
    y1: 1393.17,
    x2: -230.39,
    y2: 1398.4,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -233.59,
    y1: 1401.68,
    x2: -230.8,
    y2: 1406.91,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -234,
    y1: 1410.2,
    x2: -231.2,
    y2: 1415.42,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -234.4,
    y1: 1418.71,
    x2: -231.61,
    y2: 1423.94,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: -1436.75,
    y1: 96.57,
    x2: -1402.17,
    y2: 96.57,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: -1451.47,
    y1: 101.11,
    x2: -1424.27,
    y2: 74.97,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: -1171.62,
    y1: 600.14,
    x2: -1169.91,
    y2: 603.35,
    gradientTransform: "matrix(-0.98, 0.21, 0.21, 0.98, -1200.4, -264.83)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: -1518.82,
    y1: -34.91,
    x2: -1517.09,
    y2: -31.67,
    gradientTransform: "matrix(-1, -0.05, -0.05, 1, -1451.86, 33.26)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: -1695.69,
    y1: -810.41,
    x2: -1693.91,
    y2: -807.08,
    gradientTransform: "matrix(-0.94, -0.33, -0.33, 0.94, -1806.11, 275.75)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: -1702.17,
    y1: -1063.66,
    x2: -1700.38,
    y2: -1060.3,
    gradientTransform: "matrix(-0.91, -0.42, -0.42, 0.91, -1931.64, 330.64)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: -653.51,
    y1: 1136.61,
    x2: -651.78,
    y2: 1139.84,
    gradientTransform: "matrix(-0.89, 0.46, 0.46, 0.89, -1030.63, -628.87)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 61.15,
    y1: 1541.97,
    x2: 62.92,
    y2: 1545.28,
    gradientTransform: "matrix(-0.71, 0.7, 0.7, 0.71, -962.97, -1065.08)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: -1458.41,
    y1: 76.54,
    x2: -1457.28,
    y2: 78.65,
    gradientTransform: "matrix(-1, 0, 0, 1, -1373.21, 0)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: -1455.06,
    y1: 80.76,
    x2: -1454.17,
    y2: 82.44,
    gradientTransform: "matrix(-1, 0, 0, 1, -1373.21, 0)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: -1450.11,
    y1: 82.68,
    x2: -1447.87,
    y2: 86.87,
    gradientTransform: "matrix(-1, 0, 0, 1, -1373.21, 0)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: -1465.25,
    y1: 121.81,
    x2: -1468.14,
    y2: 107.23,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 3582.23,
    y1: -2115.02,
    x2: 3588.91,
    y2: -2094.77,
    gradientTransform: "matrix(1, 0, 0, -1, -3530.42, -1964.68)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 3599.57,
    y1: -2116.39,
    x2: 3645.68,
    y2: -2116.39,
    gradientTransform: "matrix(1, 0, 0, -1, -3530.42, -1964.68)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 2462.32,
    y1: -3439.41,
    x2: 2465.12,
    y2: -3434.18,
    gradientTransform: "matrix(0.8, -0.61, -0.61, -0.8, -3926.11, -1089.05)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 2461.91,
    y1: -3430.9,
    x2: 2464.71,
    y2: -3425.67,
    gradientTransform: "matrix(0.8, -0.61, -0.61, -0.8, -3926.11, -1089.05)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 2461.51,
    y1: -3422.38,
    x2: 2464.3,
    y2: -3417.15,
    gradientTransform: "matrix(0.8, -0.61, -0.61, -0.8, -3926.11, -1089.05)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 2461.1,
    y1: -3413.87,
    x2: 2463.89,
    y2: -3408.64,
    gradientTransform: "matrix(0.8, -0.61, -0.61, -0.8, -3926.11, -1089.05)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 2460.69,
    y1: -3405.36,
    x2: 2463.48,
    y2: -3400.13,
    gradientTransform: "matrix(0.8, -0.61, -0.61, -0.8, -3926.11, -1089.05)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 2460.28,
    y1: -3396.84,
    x2: 2463.07,
    y2: -3391.61,
    gradientTransform: "matrix(0.8, -0.61, -0.61, -0.8, -3926.11, -1089.05)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 3624.62,
    y1: -2101.49,
    x2: 3659.2,
    y2: -2101.49,
    gradientTransform: "matrix(1, 0, 0, -1, -3530.42, -1964.68)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 3609.9,
    y1: -2096.95,
    x2: 3637.1,
    y2: -2123.09,
    gradientTransform: "matrix(1, 0, 0, -1, -3530.42, -1964.68)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 3320.73,
    y1: -2603.85,
    x2: 3322.45,
    y2: -2600.63,
    gradientTransform: "matrix(0.98, -0.21, -0.21, -0.98, -3703.22, -1699.85)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 3651.07,
    y1: -1964.25,
    x2: 3652.8,
    y2: -1961.01,
    gradientTransform: "matrix(1, 0.05, 0.05, -1, -3451.77, -1997.94)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 3809.08,
    y1: -1194.06,
    x2: 3810.86,
    y2: -1190.73,
    gradientTransform: "matrix(0.94, 0.33, 0.33, -0.94, -3097.52, -2240.43)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 3814.59,
    y1: -944.22,
    x2: 3816.39,
    y2: -940.86,
    gradientTransform: "matrix(0.91, 0.42, 0.42, -0.91, -2971.99, -2295.32)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 2818.38,
    y1: -3152.46,
    x2: 2820.11,
    y2: -3149.23,
    gradientTransform: "matrix(0.89, -0.46, -0.46, -0.89, -3872.99, -1335.81)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 2118.2,
    y1: -3578.68,
    x2: 2119.97,
    y2: -3575.38,
    gradientTransform: "matrix(0.71, -0.7, -0.7, -0.71, -3940.66, -899.6)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 3602.96,
    y1: -2121.52,
    x2: 3604.08,
    y2: -2119.41,
    gradientTransform: "matrix(1, 0, 0, -1, -3530.42, -1964.68)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 3606.3,
    y1: -2117.3,
    x2: 3607.2,
    y2: -2115.62,
    gradientTransform: "matrix(1, 0, 0, -1, -3530.42, -1964.68)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 3611.26,
    y1: -2115.38,
    x2: 3613.49,
    y2: -2111.2,
    gradientTransform: "matrix(1, 0, 0, -1, -3530.42, -1964.68)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 3596.11,
    y1: -2076.26,
    x2: 3593.22,
    y2: -2090.83,
    gradientTransform: "matrix(1, 0, 0, -1, -3530.42, -1964.68)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: -1563.57,
    y1: -155.02,
    x2: -1597.92,
    y2: -194.12,
    gradientTransform: "matrix(-1, -0.1, -0.1, 1, -1481.28, 96.18)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cfd1d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a5a7aa"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: -1584.71,
    y1: -193.51,
    x2: -1568.79,
    y2: -156.46,
    xlinkHref: "#linear-gradient-42"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: -1617.2,
    y1: -308.82,
    x2: -1605.78,
    y2: -316.6,
    gradientTransform: "matrix(-0.99, -0.16, -0.16, 0.99, -1556.79, 152.08)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bec0c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: -1613.78,
    y1: -315.76,
    x2: -1620.75,
    y2: -306.21,
    xlinkHref: "#linear-gradient-44"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: -1432.89,
    y1: 158.56,
    x2: -1435.72,
    y2: 162.44,
    gradientTransform: "matrix(-1, 0.02, 0.02, 1, -1349.26, -25.81)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d38a1e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd978"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: -1453.16,
    y1: 125.92,
    x2: -1467.44,
    y2: 113.15,
    gradientTransform: "matrix(-1, 0.02, 0.02, 1, -1349.26, -25.81)",
    xlinkHref: "#linear-gradient-42"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: 3685.14,
    y1: -1858.66,
    x2: 3650.78,
    y2: -1897.77,
    gradientTransform: "matrix(1, 0.1, 0.1, -1, -3422.34, -2060.86)",
    xlinkHref: "#linear-gradient-42"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: 3664,
    y1: -1897.15,
    x2: 3679.91,
    y2: -1860.11,
    gradientTransform: "matrix(1, 0.1, 0.1, -1, -3422.34, -2060.86)",
    xlinkHref: "#linear-gradient-42"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: 3728.48,
    y1: -1677.98,
    x2: 3739.9,
    y2: -1685.76,
    gradientTransform: "matrix(0.99, 0.16, 0.16, -0.99, -3346.84, -2116.76)",
    xlinkHref: "#linear-gradient-44"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: 3731.91,
    y1: -1684.92,
    x2: 3724.93,
    y2: -1675.37,
    gradientTransform: "matrix(0.99, 0.16, 0.16, -0.99, -3346.84, -2116.76)",
    xlinkHref: "#linear-gradient-44"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: 3574.36,
    y1: -2160.37,
    x2: 3571.53,
    y2: -2156.49,
    gradientTransform: "matrix(1, -0.02, -0.02, -1, -3554.37, -1938.87)",
    xlinkHref: "#linear-gradient-46"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: 3554.09,
    y1: -2193.01,
    x2: 3539.82,
    y2: -2205.79,
    gradientTransform: "matrix(1, -0.02, -0.02, -1, -3554.37, -1938.87)",
    xlinkHref: "#linear-gradient-42"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: -1576.94,
    y: -51.82,
    width: 2406.31,
    height: 1210.9
  }), /*#__PURE__*/React.createElement("image", {
    width: 153,
    height: 217,
    transform: "translate(2.52 8.5)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJkAAADZCAYAAAAzBJLWAAAACXBIWXMAAAsSAAALEgHS3X78AAACcUlEQVR4Xu3UMWpDMRRFwSfj/W9ZKUIcGRKC43+6mUpCKg937b3n8HSBf1rn5XacBcZVnlr6ikxgXO3R1LlkcLU98xmZFSNlyahtkZETGTmRkRMZOZGRExk5kZETGTmRkRMZOZGRExk5kZETGTmRkRMZOZGRExk5kZETGTmRkRMZOZGRExk5kZETGTmRkRMZOZGRExk5kZETGTmRkRMZOZGRExk5kZETGTmRkRMZOZGRExk5kZETGTmRkRMZOZGRExk5kZETGTmRkRMZOZGRExk5kZETGTmRkRMZOZGRExk5kZETGTmRkRMZOZGRExk5kZETGTmRkRMZOZGRExk5kZETGTmRkRMZOZGRExk5kZETGTmRkRMZOZGRExk5kZETGTmRkRMZOZGRExk5kZETGTmRkRMZOZGRExk5kZETGTmRkRMZOZGRExk5kZETGTmRkRMZOZGRExk5kZETGTmRkRMZOZGRExk5kZETGTmRkRMZOZGRExk5kZETGTmRkRMZOZGRExk5kZETGTmRkRMZOZGRExk5kZETGTmRkRMZOZGRExk5kZETGTmRkRMZOZGRExk5kZETGTmRkRMZOZGRExk5kZETGTmRkRMZOZGRExk5kZETGTmRkRMZOZGRExk5kZETGTmRkRMZOZGRExk5kZETGTmRkRMZOZGRExk5kZETGTmRkRMZOZGRExk5kZETGTmRkRMZOZGRExk5kZETGTmRkRMZOZGRExk5kZETGTmRkRMZOZGRExk5kZETGTmRkRMZOZGRExk5kZETGbV1m5n11y94hyWjtGa+I7NmZM4lExpXevR0/+1hZvbAa34cqg9BIA2xxAo4AAAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    width: 12,
    height: 16,
    transform: "translate(13.52 47.5)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAQCAYAAAAiYZ4HAAAACXBIWXMAAAsSAAALEgHS3X78AAABjElEQVQoU22STW/TQBCGnx2vHGxTRyFpE8ClAgE3boCQ6L8nhRNHjuVDbSGgtjiNQ+qP3eFQxSUOI+1h9c6z78zOoKp0z8fnT/Xd+KH+TxM6cfRgX8M4BGA6ybSrbwESCPEgJt1Lu9KN/u9lOsl0dDBEAiEZJgB8yA42XFrg6P6+3h0mFJdLon6EMZAMErz3vM8etZCsk1WVMA4ZPR7hG088SEiGCVEate4toKqMn+0R9WN6cUgYh/TikHvZgN0nu4jcVi4tGQT0khCxgu1ZxApGDMZAOk4JbMB0kqkF6E/6AHi3+YsSCGKFdLyDBEL+I78pqbgo8N6j3uOdx1UO9Yp3Hu+Uxa8F1Z+KN9++GjmcnRpXO/KznOJiSb2qwUBTNtTXNU1Z09SOxfmCtunD2akBqJYl6pVqWaEo+VnO5clvVvmKt99PTAsAvDo+Nq52XBcl1aqiOC/o7dyhLEpef/ls1nlGdbPRTy9faFM2SCDMZ/PWfR1bu3T18wobWuazOWK35G0HuJ1q93WAvxOpzZ5AIQVtAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M19.51,47.57v7.88H13.66A45.77,45.77,0,0,0,19.51,47.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M19.51,63.49v-8h5.85A47.35,47.35,0,0,0,19.51,63.49Z"
  }), /*#__PURE__*/React.createElement("image", {
    width: 13,
    height: 17,
    transform: "translate(131.52 169.5)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAARCAYAAAAG/yacAAAACXBIWXMAAAsSAAALEgHS3X78AAABnUlEQVQoU3WR327aMByFv5g4gYYUNMQGGxUg9Q12tT9vPyaVPcJ2MWlr0Vaqpk0CiXFs74LCCKU/ybKl4+PvWMdzznFqrsYTV6mKz3+uvWNNnDJ8HV64uB+fkoAXTAC2ssT9mG/T6bMo3nG8+WTqXl/2kaFks95Q5orkJuHT4vc+Zo00n0ydDH1gq1vrMJWh/SqqPbwnzQYj1xv3CKOA1nkLv+njjEOXmtX9imyZ8/77D69GkqGk3YsIzkKCswAZSBpBA9mSmMpSpAWzwcjtSVcXY9cZdoj7MWE7xA98RENgKoPRhjIrKXNF+jeleCwQs8HI+aGPJwRlrjDaPAV/2sT2IISg4Tf+/2mH7b7t0hl0kKFPEAVYY7GVJVvmPCwS1GqDNXb7p13rxWNBepuilQbAaEu2zFBrRZkrdndrPc3HU+ecozvsEPUi8Dzuft6xTtbgse/K52B2hPx+RfO8iVptMNrgCY+PN79Ol7uLWWYlKlfIpkQXm5rhmenQmCweSG/TYxk4inc4larQvubDdZ0CgHPu5Pry5p17SfsHBIvyG0LJvj4AAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M138.23,185.81v-7.88h5.84A46.37,46.37,0,0,0,138.23,185.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M138.22,169.9v8h-5.84A47.14,47.14,0,0,0,138.22,169.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M16.68,19v-.59h9.37V19h-.79a2.34,2.34,0,0,0-2,.79,4.93,4.93,0,0,0-.39,2.49V33a12.3,12.3,0,0,1-.54,4,6.24,6.24,0,0,1-1.86,2.67,4.78,4.78,0,0,1-3.2,1.13,3.52,3.52,0,0,1-2.38-.75,2.22,2.22,0,0,1-.87-1.71,1.63,1.63,0,0,1,.4-1.2,1.76,1.76,0,0,1,1.24-.5,1.46,1.46,0,0,1,.93.34,5.61,5.61,0,0,1,1,1.81c.25.58.56.87.95.87a1,1,0,0,0,.81-.53,3.38,3.38,0,0,0,.38-1.89V22.32a7.3,7.3,0,0,0-.21-2.2,1.39,1.39,0,0,0-.67-.69A3,3,0,0,0,17.47,19Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "79.43 64.68 79.43 158.68 110.1 111.68 48.77 111.68 79.43 64.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M63,72.6,34.57,78S29,78.49,29,85.19V110.9l99.6,11.52s-25.12-37.5-32.95-44.2c-.88-.75-4.92-1.64-9.88-2.48C76.08,74.09,63,72.6,63,72.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M103.53,87.26s1.58,17.7-18,20.34l10,8.11s16.21-5.76,16.86-16.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M83.05,75l5.54,1.27s-1.33,11.65-18.18,12S42.48,75.88,42.48,75.88L50.39,75s11.82,7.5,20,6.09A24,24,0,0,0,83.05,75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M69.14,34.58l19.74,1.57-.52,2.19L90.85,52.1l-2.7.71.38,3.13-2.3,1.47.18,1.78s-2.55,1.06-1.06,2.57,2.8,4.39-4.3,4.79c-4.32.25-6.53,2.26-2.91,8.44,0-.57-3,4-7.66,4.3-7.17.41-17.14-3.21-17.14-3.21S68.8,40.32,69.14,34.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M87.88,38.66a2.3,2.3,0,0,1-1.24,2.92,12.72,12.72,0,0,1-2.75-.84c-1.63-.66-5.17-.23-5.65.35s1-3.29,6.62-1.61C88.33,40.5,87.88,38.66,87.88,38.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M86.92,42.07A6,6,0,0,1,83.65,42c-1.61-.55-3.84-.43-4.92.57a9.05,9.05,0,0,1,4.3.28s-.56,2,.66,2.2,1.3-2,1.3-2A3.17,3.17,0,0,0,86.92,42.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M71.46,34S71.32,57.42,73.56,63c0,0,6.23,14.21-26.3,8.63,0,0-2.53-6.1,3.52-7.08,0,0-4.31-31.24.57-30.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M47.26,71.6s-4.43-10.17,22.87-7.45C70.13,64.15,41.74,59.62,47.26,71.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M72.73,34.9s.23,20.13.93,29c0,0-4.36-18.89-3-28.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M65.59,34.44a91.25,91.25,0,0,0,.51,27.33S62,47.23,63.94,34.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M57,33.31a91.25,91.25,0,0,0,.51,27.33S53.33,46.1,55.31,33.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M88.53,53.73a8.48,8.48,0,0,0-6.2,1.56c-1.35,1.11-3,1.07-3.69,0,0,0,.45,2.49,3.85.94a8.87,8.87,0,0,1,6.28-.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M73.52,62.47s1.73,1.58.3,4.9-6.06,5.86-13.54,5.56C60.28,72.93,75.91,72.41,73.52,62.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M47.14,74.87l38.56,43L29,110.9V81.3A11.62,11.62,0,0,1,34.57,78C37.83,77.28,47.14,74.87,47.14,74.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M89.47,33.35l3.84-10.49.82-2s-13.4,3-20.17-1.07c-.45-.27-10.42,7.3-27.71,4.09l3,7.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M49.62,35.14s23.5-1.19,39.24,1L89.69,33a270.2,270.2,0,0,0-40.43-1.3Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "47.14 74.87 85.7 117.87 78.83 117.06 42.48 75.88 47.14 74.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "42.48 75.88 33.39 78.09 63.54 115.06 78.83 117.06 42.48 75.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "43.97 83.72 39.45 82.28 39.12 77.95 39.12 77.95 39.12 77.95 39.12 77.95 39.12 77.95 43.64 79.39 43.97 83.72 43.97 83.72 43.97 83.72 43.97 83.72 43.97 83.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "49.45 90.25 44.93 88.81 44.6 84.47 44.6 84.47 44.6 84.47 44.6 84.47 44.6 84.47 49.12 85.91 49.45 90.25 49.45 90.25 49.45 90.25 49.45 90.25 49.45 90.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "54.94 96.77 50.41 95.33 50.08 91 50.08 91 50.08 91 50.08 91 50.08 91 54.61 92.44 54.94 96.77 54.94 96.77 54.94 96.77 54.94 96.77 54.94 96.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "60.42 103.3 55.9 101.86 55.57 97.52 55.57 97.52 55.57 97.52 55.57 97.52 55.57 97.52 60.09 98.96 60.42 103.3 60.42 103.3 60.42 103.3 60.42 103.3 60.42 103.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "65.91 109.82 61.38 108.38 61.05 104.05 61.05 104.05 61.05 104.05 61.05 104.05 61.05 104.05 65.58 105.49 65.91 109.82 65.91 109.82 65.91 109.82 65.91 109.82 65.91 109.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "71.39 116.35 66.86 114.91 66.53 110.57 66.53 110.57 66.53 110.57 66.53 110.57 66.53 110.57 71.06 112.01 71.39 116.35 71.39 116.35 71.39 116.35 71.39 116.35 71.39 116.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M33.39,78.09S29,78.89,29,81.3l26.82,32.75,7.76,1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "47.14 74.87 85.7 117.87 108.31 120.38 48.91 74.87 47.14 74.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M76.84,71.93,83.05,75S77.72,82.91,68,82.37,50.39,75,50.39,75l4.71-2.62S61.47,76.88,68.56,77,76.84,71.93,76.84,71.93Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "89.62 32.95 88.36 25.78 93.91 21.56 89.62 32.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "84.04 26.73 87.39 28.07 88.64 32.19 85.05 30.4 84.04 26.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M46.25,23.91A46.13,46.13,0,0,0,74,19.82s6.65,3.74,20.17,1.07c0,0-10.64,4.46-20.17.54C74,21.43,65.42,27.41,46.25,23.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M89.62,33S66.35,30.4,49.26,31.69C49.26,31.69,65.16,28.59,89.62,33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M89.62,33l-.76,3.2s-21.79-2-39.24-1c-.93,0,.24-.26.24-.26s20.66-1.2,38.28.21C88.14,35.09,88.88,34.92,89.62,33Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "70.66 81.85 68.52 79.94 69.61 77.41 69.61 77.41 69.61 77.41 69.61 77.41 69.61 77.41 71.75 79.32 70.66 81.85 70.66 81.85 70.66 81.85 70.66 81.85 70.66 81.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "65.72 81.77 64.2 79.42 65.98 77.23 65.98 77.23 65.98 77.23 65.98 77.23 65.98 77.23 67.5 79.58 65.72 81.77 65.72 81.77 65.72 81.77 65.72 81.77 65.72 81.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "60.73 80.7 60.01 78.06 62.4 76.42 62.4 76.42 62.4 76.42 62.4 76.42 62.4 76.42 63.12 79.06 60.73 80.7 60.73 80.7 60.73 80.7 60.73 80.7 60.73 80.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "56.97 79.15 56.52 76.46 59.07 75.02 59.07 75.02 59.07 75.02 59.07 75.02 59.07 75.02 59.52 77.71 56.97 79.15 56.97 79.15 56.97 79.15 56.97 79.15 56.97 79.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "75.43 80.44 72.81 79.12 73.11 76.41 73.11 76.41 73.11 76.41 73.11 76.41 73.11 76.41 75.73 77.73 75.43 80.44 75.43 80.44 75.43 80.44 75.43 80.44 75.43 80.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "79.14 78.17 76.2 77.6 75.61 74.94 75.61 74.94 75.61 74.94 75.61 74.94 75.61 74.94 78.55 75.5 79.14 78.17 79.14 78.17 79.14 78.17 79.14 78.17 79.14 78.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "87.92 77.69 82.16 76.08 81.12 77.02 87.63 79.16 87.92 77.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "79.06 79.02 85.11 82.78 83.93 83.98 78.02 79.83 79.06 79.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "75.21 81.17 78.61 86.93 76.25 87.6 73.44 81.7 75.21 81.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M51.57,36.3S48.71,55.89,50.8,63c0,0-3.11-22.55-.51-27.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M70.13,64.15S51.79,62.42,47.8,67.64c0,0,4.66-3,4.66-1,0,0,1.33-1.6,1.33-.6s7.31-2,7.31-.2c0,0,6.65-1.81,6.43.4S70.13,64.15,70.13,64.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M63.34,64s-7.73,4.81-.67,8.44C62.67,72.41,57.42,69,63.34,64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M55.77,64s-7.72,4.81-.67,8.44C55.1,72.39,49.85,69,55.77,64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M71.11,63.8s-7.84,3.72-.9,6.31C70.21,70.11,65.06,67.67,71.11,63.8Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-31"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "35.31 84.47 31.23 83.14 31.01 79.22 31.01 79.22 31.01 79.22 31.01 79.22 31.01 79.22 35.09 80.55 35.31 84.47 35.31 84.47 35.31 84.47 35.31 84.47 35.31 84.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "40.19 90.41 36.1 89.08 35.88 85.15 35.88 85.15 35.88 85.15 35.88 85.15 35.88 85.15 39.96 86.48 40.19 90.41 40.19 90.41 40.19 90.41 40.19 90.41 40.19 90.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "45.05 96.34 40.97 95.01 40.74 91.09 40.74 91.09 40.74 91.09 40.74 91.09 40.74 91.09 44.83 92.42 45.05 96.34 45.05 96.34 45.05 96.34 45.05 96.34 45.05 96.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "49.92 102.28 45.84 100.95 45.61 97.02 45.61 97.02 45.61 97.02 45.61 97.02 45.61 97.02 49.69 98.35 49.92 102.28 49.92 102.28 49.92 102.28 49.92 102.28 49.92 102.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "54.79 108.21 50.7 106.88 50.48 102.96 50.48 102.96 50.48 102.96 50.48 102.96 50.48 102.96 54.56 104.28 54.79 108.21 54.79 108.21 54.79 108.21 54.79 108.21 54.79 108.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "59.65 114.15 55.57 112.82 55.34 108.89 55.34 108.89 55.34 108.89 55.34 108.89 55.34 108.89 59.43 110.22 59.65 114.15 59.65 114.15 59.65 114.15 59.65 114.15 59.65 114.15"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M49.26,31.69a20.26,20.26,0,0,1-2.35,11.74l2.11-1,.89,1.41s3-4.62,1.66-12.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M119.32,118.14,89.77,104.47s-4.44,3.22-5.17,13.4l42.85,4.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M92.89,106.52s-6.82-2.13-8.92-5.06c0,0-2.42-.16-2.44.12s-.15,1.85-.57,2-1.86.44-1.9,1,.22,2.35-.11,2.7-1.18.76-.88,2-.68,2.28-.7,2.56,2.55,3.52,8.06,5.56C85.43,117.4,91.4,107.35,92.89,106.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M94.13,105.14S88.59,111.77,89,118l-4.66-.4s-.66-10,6.21-14.46Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "28.96 81.3 55.78 114.05 54.82 113.98 28.81 82.37 28.96 81.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "63.54 115.06 33.39 78.09 34.57 77.95 65.31 115.19 63.54 115.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "47.14 74.87 45.8 79.69 53.78 82.51 54.97 89.87 62.5 92.02 63.09 99.12 70.78 101.13 72.26 109.16 78.61 109.97 47.14 74.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M88.92,118.17s-.56-5.12,4-11.9c0,0,6,2.36,6,2.36s-4.25,7-3.8,10.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M94.79,160.79l28.37-5.36s5.62-.53,5.62-7.23V122.48L29.18,111s25.12,37.51,33,44.2c.88.75,4.92,1.64,9.88,2.49C81.66,159.3,94.79,160.79,94.79,160.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M54.21,146.13s-1.58-17.71,17.95-20.34l-10-8.11s-16.22,5.76-16.86,16.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M74.69,158.38l-5.54-1.27s1.33-11.66,18.18-12.06,27.93,12.46,27.93,12.46l-7.91.87s-11.82-7.5-20-6.1A24,24,0,0,0,74.69,158.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M88.6,198.81l-19.74-1.57.51-2.19-2.49-13.76,2.71-.72-.38-3.13,2.3-1.47-.18-1.77s2.55-1.07,1.06-2.58-2.8-4.39,4.3-4.79c4.32-.24,6.52-2.25,2.91-8.44,0,.58,3-4,7.66-4.3,7.17-.41,17.14,3.21,17.14,3.21S88.94,193.06,88.6,198.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M69.86,194.73a2.29,2.29,0,0,1,1.24-2.92,12.26,12.26,0,0,1,2.75.83c1.62.67,5.17.23,5.65-.34s-1,3.28-6.62,1.61C69.41,192.88,69.86,194.73,69.86,194.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M70.82,191.31a6.1,6.1,0,0,1,3.26.08c1.62.56,3.85.44,4.93-.57a9.14,9.14,0,0,1-4.3-.27s.56-2-.66-2.21-1.3,2-1.3,2A3.17,3.17,0,0,0,70.82,191.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M86.28,199.35s.14-23.39-2.1-28.94c0,0-6.23-14.21,26.3-8.62,0,0,2.53,6.1-3.52,7.08,0,0,4.31,31.23-.58,30.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M110.48,161.79s4.43,10.16-22.88,7.44C87.6,169.23,116,173.76,110.48,161.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M85,198.48s-.22-20.13-.92-29c0,0,4.35,18.9,3,28.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M92.15,199a91.25,91.25,0,0,0-.51-27.33s4.13,14.54,2.16,27.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M100.79,200.07a91.47,91.47,0,0,0-.52-27.33s4.14,14.54,2.16,27.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M69.21,179.65a8.42,8.42,0,0,0,6.2-1.56c1.35-1.11,3-1.07,3.69,0,0,0-.45-2.49-3.85-.94a8.9,8.9,0,0,1-6.28.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M84.22,170.91s-1.73-1.58-.3-4.89,6.06-5.86,13.54-5.57C97.46,160.45,81.83,161,84.22,170.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M110.6,158.51,72,115.52l56.75,7v29.6a11.62,11.62,0,0,1-5.62,3.35C119.91,156.1,110.6,158.51,110.6,158.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M68.27,200l-3.85,10.48-.81,2s13.4-3,20.17,1.06c.45.27,10.42-7.29,27.71-4.09l-3-7.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M108.11,198.24s-23.49,1.19-39.23-1L68,200.39a270.38,270.38,0,0,0,40.44,1.3Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "110.6 158.51 72.03 115.52 78.91 116.32 115.26 157.51 110.6 158.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "115.26 157.51 124.35 155.3 94.2 118.33 78.91 116.32 115.26 157.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "113.77 149.66 118.29 151.1 118.62 155.44 118.62 155.44 118.62 155.44 118.62 155.44 118.62 155.44 114.1 154 113.77 149.66 113.77 149.66 113.77 149.66 113.77 149.66 113.77 149.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "108.28 143.14 112.81 144.58 113.14 148.91 113.14 148.91 113.14 148.91 113.14 148.91 113.14 148.91 108.61 147.47 108.28 143.14 108.28 143.14 108.28 143.14 108.28 143.14 108.28 143.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "102.8 136.61 107.33 138.05 107.66 142.39 107.66 142.39 107.66 142.39 107.66 142.39 107.66 142.39 103.13 140.95 102.8 136.61 102.8 136.61 102.8 136.61 102.8 136.61 102.8 136.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "97.32 130.09 101.84 131.53 102.17 135.86 102.17 135.86 102.17 135.86 102.17 135.86 102.17 135.86 97.65 134.42 97.32 130.09 97.32 130.09 97.32 130.09 97.32 130.09 97.32 130.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-43",
    points: "91.83 123.56 96.36 125 96.69 129.34 96.69 129.34 96.69 129.34 96.69 129.34 96.69 129.34 92.17 127.9 91.83 123.56 91.83 123.56 91.83 123.56 91.83 123.56 91.83 123.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-44",
    points: "86.35 117.04 90.87 118.48 91.21 122.81 91.21 122.81 91.21 122.81 91.21 122.81 91.21 122.81 86.68 121.37 86.35 117.04 86.35 117.04 86.35 117.04 86.35 117.04 86.35 117.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M124.35,155.3s4.43-.81,4.43-3.22L102,119.33l-7.76-1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-46",
    points: "110.6 158.51 72.03 115.52 49.43 113 108.83 158.51 110.6 158.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M80.9,161.46l-6.21-3.08S80,150.47,89.77,151s17.58,7.37,17.58,7.37L102.64,161s-6.37-4.49-13.46-4.62S80.9,161.46,80.9,161.46Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "68.12 200.44 69.37 207.6 63.83 211.82 68.12 200.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "73.69 206.66 70.35 205.31 69.09 201.19 72.69 202.99 73.69 206.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M111.49,209.47a46.13,46.13,0,0,0-27.71,4.09s-6.65-3.74-20.17-1.06c0,0,10.64-4.46,20.17-.54C83.78,212,92.32,206,111.49,209.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M68.12,200.44s23.27,2.54,40.36,1.25C108.48,201.69,92.57,204.79,68.12,200.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M68.12,200.44l.76-3.21s21.79,2,39.23,1c.94-.05-.23.26-.23.26s-20.66,1.2-38.28-.21C69.6,198.29,68.86,198.46,68.12,200.44Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-47",
    points: "87.08 151.53 89.22 153.44 88.13 155.97 88.13 155.97 88.13 155.97 88.13 155.97 88.13 155.97 85.99 154.06 87.08 151.53 87.08 151.53 87.08 151.53 87.08 151.53 87.08 151.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-48",
    points: "92.02 151.62 93.54 153.97 91.76 156.16 91.76 156.16 91.76 156.16 91.76 156.16 91.76 156.16 90.24 153.81 92.02 151.62 92.02 151.62 92.02 151.62 92.02 151.62 92.02 151.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "97.01 152.68 97.73 155.32 95.34 156.97 95.34 156.97 95.34 156.97 95.34 156.97 95.34 156.97 94.62 154.33 97.01 152.68 97.01 152.68 97.01 152.68 97.01 152.68 97.01 152.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-50",
    points: "100.77 154.23 101.22 156.92 98.67 158.36 98.67 158.36 98.67 158.36 98.67 158.36 98.67 158.36 98.22 155.67 100.77 154.23 100.77 154.23 100.77 154.23 100.77 154.23 100.77 154.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-51",
    points: "82.31 152.94 84.93 154.27 84.62 156.97 84.62 156.97 84.62 156.97 84.62 156.97 84.62 156.97 82 155.65 82.31 152.94 82.31 152.94 82.31 152.94 82.31 152.94 82.31 152.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-52",
    points: "78.6 155.22 81.54 155.78 82.12 158.45 82.12 158.45 82.12 158.45 82.12 158.45 82.12 158.45 79.19 157.88 78.6 155.22 78.6 155.22 78.6 155.22 78.6 155.22 78.6 155.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-53",
    points: "69.82 155.7 75.58 157.31 76.62 156.37 70.11 154.23 69.82 155.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-54",
    points: "78.68 154.36 72.63 150.61 73.81 149.4 79.72 153.56 78.68 154.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-55",
    points: "82.53 152.22 79.13 146.46 81.49 145.79 84.3 151.68 82.53 152.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M106.17,197.09s2.86-19.6.76-26.68c0,0,3.12,22.56.52,27.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M87.6,169.23S106,171,109.94,165.75c0,0-4.66,3-4.66,1,0,0-1.33,1.61-1.33.6s-7.31,2-7.31.2c0,0-6.65,1.81-6.43-.4S87.6,169.23,87.6,169.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M94.4,169.42s7.73-4.82.67-8.45C95.07,161,100.32,164.37,94.4,169.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M102,169.44s7.72-4.82.67-8.45C102.64,161,107.89,164.39,102,169.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M86.63,169.59s7.84-3.73.9-6.32C87.53,163.27,92.68,165.72,86.63,169.59Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-31"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "122.42 148.91 126.51 150.24 126.73 154.17 126.73 154.17 126.73 154.17 126.73 154.17 126.73 154.17 122.65 152.84 122.42 148.91 122.42 148.91 122.42 148.91 122.42 148.91 122.42 148.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "117.55 142.98 121.64 144.31 121.86 148.23 121.86 148.23 121.86 148.23 121.86 148.23 121.86 148.23 117.78 146.91 117.55 142.98 117.55 142.98 117.55 142.98 117.55 142.98 117.55 142.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "112.69 137.04 116.77 138.37 117 142.3 117 142.3 117 142.3 117 142.3 117 142.3 112.91 140.97 112.69 137.04 112.69 137.04 112.69 137.04 112.69 137.04 112.69 137.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "107.82 131.11 111.91 132.44 112.13 136.36 112.13 136.36 112.13 136.36 112.13 136.36 112.13 136.36 108.05 135.03 107.82 131.11 107.82 131.11 107.82 131.11 107.82 131.11 107.82 131.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "102.95 125.17 107.04 126.5 107.26 130.43 107.26 130.43 107.26 130.43 107.26 130.43 107.26 130.43 103.18 129.1 102.95 125.17 102.95 125.17 102.95 125.17 102.95 125.17 102.95 125.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "98.09 119.24 102.17 120.57 102.4 124.49 102.4 124.49 102.4 124.49 102.4 124.49 102.4 124.49 98.31 123.16 98.09 119.24 98.09 119.24 98.09 119.24 98.09 119.24 98.09 119.24"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M108.48,201.69A20.27,20.27,0,0,1,110.82,190l-2.1,1-.89-1.4s-3,4.62-1.66,12.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M38.42,115.25,68,128.91s4.43-3.21,5.17-13.39L30.29,111Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M64.85,126.87s6.82,2.12,8.92,5.06c0,0,2.42.16,2.44-.12s.15-1.86.57-2,1.86-.43,1.9-1-.22-2.35.11-2.7,1.18-.76.87-2,.69-2.29.71-2.56S77.82,118,72.31,116C72.31,116,66.34,126,64.85,126.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M63.61,128.24s5.54-6.63,5.1-12.86l4.65.4s.67,10-6.2,14.47Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "128.78 152.08 101.96 119.33 102.92 119.4 128.93 151.01 128.78 152.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "94.2 118.33 124.35 155.3 123.17 155.43 92.43 118.19 94.2 118.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "110.6 158.51 111.93 153.69 103.95 150.88 102.77 143.51 95.23 141.37 94.64 134.27 86.96 132.26 85.48 124.22 79.13 123.42 110.6 158.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M68.82,115.22s.56,5.12-4,11.89c0,0-6-2.35-6-2.35s4.25-7,3.8-10.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M91.32,105.59s-4.19-5.9-6-6.06l17.9-35.48s3.63-9.17,18.61-8.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M113.85,61l-25.58,41.4-.89-1.72L105.49,67S106.48,63.31,113.85,61Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-59",
    points: "113.67 60.88 88.45 102.14 89.52 103.56 113.67 60.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M88.47,101.07l-2.75-2.85,1.22-1.85s-6.38-1.34-9,.83c0,0,5.19,1.77,7.84,5.81s10.33,5.06,12.51,4.16c0,0-4.26-2.91-5.13-5l-.63,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M93.15,102.2l-.54.82-4.14-2-2.75-2.85,1.22-1.85A14.45,14.45,0,0,0,82.41,96a26,26,0,0,1,5.43,5.87c1.89,3.13,8.36,3.73,8.36,3.73S93.23,103.15,93.15,102.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M86.94,96.37s-1.71.84-1.58,1.34,3.11,3.36,3.11,3.36l4,2.16L89,100.54l-2.74-2.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M121.78,55.61,93.47,102.72l-2.07-.09s25.84-44.26,26.3-44.79C118.42,57,121.78,55.61,121.78,55.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M117.7,57.84a16.21,16.21,0,0,0-15.17,7.7s4.12-11.75,19.25-9.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M66.91,126.8s4.2,5.89,6,6L55,168.34s-3.63,9.16-18.62,8.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M44.39,171.4,70,130l.89,1.73L52.75,165.39S51.76,169.08,44.39,171.4Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-59",
    points: "44.57 171.51 69.78 130.25 68.72 128.83 44.57 171.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M69.77,131.32l2.75,2.84L71.3,136s6.38,1.33,9-.83c0,0-5.19-1.77-7.84-5.82S62.14,124.31,60,125.22c0,0,4.26,2.9,5.13,5l.63-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M65.09,130.18l.53-.82,4.15,2,2.75,2.84L71.3,136a14.56,14.56,0,0,0,4.53.38,25.79,25.79,0,0,1-5.43-5.87c-1.89-3.12-8.37-3.72-8.37-3.72S65,129.24,65.09,130.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M71.3,136s1.71-.84,1.58-1.34-3.11-3.36-3.11-3.36l-4-2.17,3.54,2.69L72,134.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M36.46,176.78l28.31-47.11,2.07.08S41,174,40.54,174.55C39.82,175.36,36.46,176.78,36.46,176.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M40.54,174.55a16.2,16.2,0,0,0,15.17-7.71s-4.13,11.75-19.25,9.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M140.35,213.64v.6H131v-.6h.79a2.32,2.32,0,0,0,2-.79,5,5,0,0,0,.38-2.48V199.68a12.26,12.26,0,0,1,.54-4,6.24,6.24,0,0,1,1.86-2.67,4.75,4.75,0,0,1,3.2-1.14,3.52,3.52,0,0,1,2.38.75,2.23,2.23,0,0,1,.88,1.72,1.59,1.59,0,0,1-.41,1.19,1.72,1.72,0,0,1-1.24.5,1.43,1.43,0,0,1-.93-.34,5.41,5.41,0,0,1-1-1.8c-.24-.58-.56-.87-.95-.87a1,1,0,0,0-.81.53,3.34,3.34,0,0,0-.38,1.89v14.93a7.17,7.17,0,0,0,.21,2.19,1.47,1.47,0,0,0,.68.7,3,3,0,0,0,1.46.38Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg11D);
export default __webpack_public_path__ + "static/media/11_d.f97f16ad2227729dd34e5155922066f3.svg";
export { ForwardRef as ReactComponent };